import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-custom-cell-button',
    templateUrl: './custom-cell-button.component.html',
    styleUrls: ['./custom-cell-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CustomCellButtonComponent implements ICellRendererAngularComp {
    label = signal<string>('');
    visible = signal<boolean>(true);
    private params!: ICellRendererParams<any, any, any>;

    agInit(params: ICellRendererParams<any, any, any>): void {
        this.params = params;

        const config = params.colDef?.cellRendererParams as {
            label?: string;
            action?: (data: any) => void;
        };

        this.label.set(config?.label ?? '');
        this.visible.set(!!params.value);
    }

    refresh(): boolean {
        return false;
    }

    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        const config = (this.params.colDef?.cellRendererParams || {}) as {
            label?: string;
            action?: (data: any) => void;
        };
        config.action?.(this.params.data);
    }
}
